export function lerp(
  fromValue: number,
  targetValue: number,
  lerpValue: number,
  snap: number = 0,
): number {
  const result = fromValue + lerpValue * (targetValue - fromValue);

  if (snap !== 0 && Math.abs(fromValue - targetValue) <= snap) {
    return targetValue;
  }

  return result;
};
